module.exports = __webpack_public_path__ + "img/plunger.c708def9.svg";